/** Angular */
import { coerceArray } from '@angular/cdk/coercion';
import { Inject, Injectable, Optional } from '@angular/core';
/** Sixense */
import { BYD_FEATURE_FLAGS_INJECTION_TOKEN } from '../configs/byd-feature-flags-injection-token';
import { BydRuntimeService } from '@sixense/byd-lib-runtime';

@Injectable({
  providedIn: 'root',
})
export class BydFeatureFlagService<T = null> {
  /**
   * @param bydRuntimeService retrieve the environment configuration data from injected file under assets
   * @param featureFlagsKey the feature flags key in the environment file
   */
  constructor(
    private bydRuntimeService: BydRuntimeService<T>,
    @Optional() @Inject(BYD_FEATURE_FLAGS_INJECTION_TOKEN) public featureFlagsKey?: string
  ) {}

  /**
   * Check the feature flags key(s) precense & state in the run time environment file.
   *
   * @param flags the feature flags key(s) from the directive
   * @returns boolean
   */
  hasFlags(flags: string | string[]): boolean {
    const environmentFeatureFlags = <T>this.bydRuntimeService?.environment?.[this.featureFlagsKey];
    return coerceArray(flags).every((flag) => environmentFeatureFlags?.[flag as keyof T]);
  }
}
